import { SaveToCloudStatus } from 'owa-attachment-savetocloud';
import { ClientItemId, MailboxType } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { SaveOneFileToGroupFilesText } from 'owa-locstrings/lib/strings/saveonefiletogroupfilestext.locstring.json';
import { SaveOneFileToOneDriveConsumerText } from 'owa-locstrings/lib/strings/saveonefiletoonedriveconsumertext.locstring.json';
import { SavingLabel } from 'owa-locstrings/lib/strings/savinglabel.locstring.json';
import { getUserConfiguration } from 'owa-session-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazySxSStoreModule, SxSStore } from 'owa-sxs-store';
import {
    FailedSaveToOneDriveSxSText,
    SavedOneFileToOneDriveSxSText,
} from './getSaveToCloudButton.locstring.json';

export default function getSaveToCloudButton(sxsStore: SxSStore) {
    const buttonLabel = getButtonLabel(
        sxsStore.extendedViewState.saveToCloudStatus,
        sxsStore.editState.itemId
    );
    const saveToCloudButton = new FilterableMenuItem(
        buttonLabel,
        ControlIcons.CloudUpload,
        async () => {
            // action
            const sxsStoreModule = await lazySxSStoreModule.import();
            sxsStoreModule.saveToCloud('SxSCommandBar');
        },
        () => {
            if (sxsStore.extendedViewState.saveToCloudStatus === SaveToCloudStatus.disabled) {
                return false;
            }

            if (isGroup(sxsStore.editState.itemId) && isConsumer()) {
                return false;
            }

            if (getUserConfiguration().SessionSettings.IsShadowMailbox) {
                return false;
            }

            return true;
        },
        null,
        sxsStore.extendedViewState.saveToCloudStatus !== SaveToCloudStatus.available
    );
    return saveToCloudButton;
}

function getButtonLabel(saveToCloudStatus: SaveToCloudStatus, itemId: ClientItemId) {
    switch (saveToCloudStatus) {
        case SaveToCloudStatus.available:
            return isGroup(itemId)
                ? loc(SaveOneFileToGroupFilesText)
                : loc(SaveOneFileToOneDriveConsumerText);
        case SaveToCloudStatus.saving:
            return loc(SavingLabel);
        case SaveToCloudStatus.succeeded:
            return loc(SavedOneFileToOneDriveSxSText);
        case SaveToCloudStatus.failed:
            return loc(FailedSaveToOneDriveSxSText);
        default:
            return '';
    }
}

function isGroup(itemId: ClientItemId) {
    return itemId?.mailboxInfo?.type === MailboxType.GroupMailbox;
}
